<ng-template #content1 let-modal1>
    <div class="modal-body dashboard_model">
        <div class="col-md-12 d-flex align-items-center justify-content-between
            mb-3">
            <div class="cancel-del-align ml-auto">
                <button type="button" class="cstm_btn_css">
                    <img (click)="modal1.dismiss(content1)" src="./assets/icons/close.svg" alt="Close"
                    class="pointers"/>
                </button>
            </div>
        </div>
        <div>
            <h1 class="info_head" *ngIf="infoNote == 'HALDIA'">Note: DG kWh is
                manual entry, daily basis</h1>
            <h1 class="info_head" *ngIf="infoNote == 'PUDUCHERRY'">Note: Energy consumption tiles of Puducherry shall be
                refreshed in day frequency as PW & PP Plant consumption are in manual entry basis. In addition to that,
                2 DG set & 2 solar plant generation are also manually entered.</h1>
            <!--  *ngIf="infoNote == HALDIA" <app-table class="info_table" [tableHead]="tableConstantHeader" [sorting]="false"
                [data]="tableConstantData" [maxHeight]="'5rem'">
            </app-table> -->
        </div>
        <div class="info_detail_table">
            <h2 class="info_head">Consumption</h2>
            <app-table class="info_table" [tableHead]="tableconsumptionHeader" [sorting]="false"
                [data]="tableconsumptionData" [maxHeight]="'5rem'"> </app-table>
        </div>
        <div class="info_detail_table">
            <h2 class="info_head">Production</h2>
            <app-table class="info_table" [tableHead]="tableProductionHeader" [sorting]="false"
                [data]="tableProductionData" [maxHeight]="'5rem'"> </app-table>
        </div>
    </div>
</ng-template>
<ng-template #content let-modal>
    <div class="modal-body">
        <div class="logout_content">
            <p class="logout_head">
                Do you want to Logout or Exit the current application?
            </p>
            <div class="d-flex align-items-center justify-content-center
                logout_btn">
                <button class="cstm_btn_css blue_btn mx-2" type="button" (click)="logout(content)">
                    Logout
                </button>
                <button class="cstm_btn_css blue_btn mx-2" type="button" (click)="modal.dismiss(content)">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</ng-template>

<mat-toolbar color="primary" class="justify-content-center">
    <mat-toolbar-row>
        <div class="nav_header_row">
            <div class="nav_header_col_lft">
                <div class="logocus"></div>
                <!-- <div class="verticalLine"></div>
            <div class="logoTCS"></div> -->
            </div>
            <div class="nav_header_col_mid">
                <div class="d-flex align-items-center">
                    <span class="module_heading" *ngIf="!dashboardFlag">
                        {{ pageTitle }} 
                    </span>
                    <!------------------------------------Bell Icon---------------------------------------------->
                    <!-- <span *ngIf="PlantFlag" class="ml-3">
                        <img (click)="updatedIcon(content1)" src="./assets/icons/redalert.svg" alt="Alert" 
                        style="cursor: pointer; height:1.25rem;"/>
                    </span> -->
                    <!------------------------------------Bell Icon---------------------------------------------->
                    <!-- <span class="module_heading" *ngIf="(dashboardFlag || PlantFlag)">{{ pageTitle }} DASHBOARD</span>
                    <div *ngIf="(dashboardFlag)">
                        <select class="form-control dashboard_select" name="selectedView" [(ngModel)]="selectedView"
                            (change)="changeGraphOrMapView($event)">
                            <option [ngValue]="b" *ngFor="let b of graphOrMapView">
                                {{ b }}
                            </option>
                        </select>
                    </div> -->
                </div>
            </div>
            <div class="nav_header_col_rgt ">
                <div class="d-flex flex-column d-sm-block">
                    <div class="logoTCS"></div>
                    <div class="dateShowCss">
                        <div *ngIf="PlantFlag">
                        {{ lastUpdatedText }}
                        <button class="cstm_btn_css">
                            <img src="./assets/icons/menu/info.svg" alt="" (click)="updatedIcon(content1)" />
                        </button>
                    </div>
                    </div>
                </div>
                <!-- <div class="dropdown">
                    <button class="d-flex align-items-center cstm_btn_css" type="button" (click)="onClickFilter()">
                        <img src="./assets/icons/filter.svg" alt="Profile" style="width: calc(100vw - 98vw);"/>
                    </button>
                </div> -->
            </div>
        </div>
    </mat-toolbar-row>
</mat-toolbar>

<div class="row">
    <div class="navBar">
        <ul class="ulPad">
            <li class="navBarContent nav_list">
                <span> <img class="iconsCss" src="./assets/icons/menu/user.svg" /></span>
                <span class="link-text text_transformation" matTooltip="{{trimUser}}"matTooltipPosition="left">{{userName}}</span>
            </li>
            <li #rla="routerLinkActive" class="navBarContent position-relative"
                *ngFor="let obj of routerData; let i= index" (click)="onNavigationClick(obj)" [routerLink]="obj.link"
                [routerLinkActive]="['is-active', 'activeRouteClass']">
                <div><img class="iconsCss" [routerLinkActive]="['is-active']" src="{{ rla.isActive ? obj.image   : obj.selectedImage }}" />
                </div>
                <span class="badge" *ngIf="obj.title === 'ALERTS'">{{notiCount.count}}</span>&nbsp;
                <div class="link-text">{{ obj["title"] }}</div>
            </li>
            &nbsp;
            <li class="navBarContent" (click)="logoutConfirm(content)">
                <span><img class="iconsCss" src="./assets/icons/menu/logout.svg" /></span>
                <span class="link-text">LOGOUT</span>
            </li>
        </ul>
    </div>
</div>

<div class="filter">
    <div class="row filter_wrapper d-flex justify-content-between">
        <!-- <app-plant-view (messageAlert)="updatedIcon($event)"></app-plant-view> -->
        <app-filter class="w-100" [disableFilter]="filterDisableFlag" [disableArr]="filterDisableArr"
            (notificationEvent)="receiveMessage($event)" [selectedValue]="selectedValue"></app-filter>
<!--

        <div class="select_filter_row module_card w-100">
            <mat-chip-list>
                <section class="list-with-scroll">
                    <div class="list" #list>
                        <ng-container *ngFor="let obj of matChipDisplayArray | keyvalue:  keyDescOrder; let i= index">
                            
                         ---------------Already hide---------------->
                            <!-- {{ matChipDisplayArray | json }} -->
                            <!-- <ng-container *ngIf="obj.key == 'assets' && obj?.value && obj?.value.length > 0">
                                <ng-container *ngFor="let obj1 of obj?.value; let j = index">
                                    <ng-container *ngFor="let result1 of obj1.value">
                                        <mat-chip [removable]="removable" (removed)="remove(result1, obj.key, j)"
                                            class="filterResultChip">
                                            <span style="white-space: nowrap;overflow: hidden;text-overflow: clip;">{{ onLabelChange(result1, obj.key, j) }}</span>
                                            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                        </mat-chip>
                                    </ng-container>
                                </ng-container>
                            </ng-container> -->
                            <!-----------------Already hide---------------->

 <!--
                            <ng-container *ngIf="obj.key == 'geoFilter' && obj.key != 'assets'">
                                <ng-container *ngFor="let r of obj.value">
                                    <mat-chip [removable]="removable" (removed)="remove(result1, obj.key, i)"
                                        class="filterResultChip">
                                        <span style="text-transform: capitalize
                                            !important; white-space: nowrap; overflow:
                                            hidden; text-overflow: clip;" class="list_grey item">{{ r.value }}</span>
                                    </mat-chip>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="obj.key != 'geoFilter' && obj.key !='assets'">
                                <ng-container *ngIf="!((assetBreakUpFlag || dashboardFlag || kpiFlag || trendsFlag || assetViewFlag ||
                                    analyticsFlag ||  adminFlag || toolsFlag || ipmvpFlag || rawDataFlag) && obj.key == 'assetFilter')">
                                    <ng-container *ngIf="obj.key != 'climaticFilter' || (obj.key == 'climaticFilter' && (this.kpiFlag ||
                                        this.dataExplorerFlag || this.dashboardFlag))">
                                        <ng-container *ngFor="let result1 of obj?.value[0]?.value; let i= index">
                                            ---------------Already hide---------------->
                                            <!-- <div *ngIf= "(obj?.value[0]?.value.length-1-i) as result1"> -->
                                            <!-- {{obj?.value[0]?.value | json}} -->
                                            <!-- {{ obj?.value[0]?.value | json}} -->
                                           <!-- <div class="filter_list"> -->
                                              <!-----------------Already hide---------------->
                                              <!---  <mat-chip [removable]="removable" (removed)="remove(result1, obj.key, i)"
                                                    class="filterResultChip" >
                                                    <span style="text-transform: capitalize
                                                        !important; white-space: nowrap;
                                                        overflow: hidden; text-overflow:
                                                        clip;" class="list_grey item">{{onLabelChange(result1, obj.key) }}</span>
                                                </mat-chip>
                                                 
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </div>
                <button id="scroll-left" class="scroller cstm_btn_css" *ngIf="isOverflown(list)" [class.disable]="!canScrollStart(list)" (click)="scroll(list,-1)">
                    <i class="fa fa-angle-left" aria-hidden="true"></i></button>
                <button id="scroll-right" class="scroller cstm_btn_css" *ngIf="isOverflown(list)" [class.disable]="!canScrollEnd(list)" (click)="scroll(list,1)"> 
                    <i class="fa fa-angle-right" aria-hidden="true"></i></button>
              </section>
            </mat-chip-list>
        </div>

        
-->
        
    </div>

    <!-- <div class="router_outlet_content" style="padding-left: 5rem; padding-right: 1rem">
        <ng-container>
            <div class="module_card">
                <app-tabsdisble class="tab_class" [tabsArr]="uiTabs" [selectedIndex]="selectedTabIndex"
                    (tabClicked)="uiSwitchTab($event, uiTabs)">
                </app-tabsdisble>
                <mat-tab-group animationDuration="0ms" [disableRipple]="true" (selectedTabChange)="tabChange($event)" [(selectedIndex)]="selectedIndex">
                <mat-tab *ngFor="let t of uiTabs" [label]="t.name" [disabled]='t.disable'></mat-tab>
            </mat-tab-group>
            </div>
        </ng-container>
        <router-outlet></router-outlet>
    </div> -->

    <ng-container>
        <div class="tabbing_wrapper" [class.tab_content_two]="kpiFlag || kpisubFlag || breakupFlag || trendsFlag || comparisonFlag || comparisonPlantFlag || ipmvpFlag" [ngClass]="reportFlag || alertFlag || dadqFlag || adminFlag || assetViewFlag || assetViewFlag ? 'tab_content_one': ''">
            <div class="tab_section_two" *ngIf="kpiFlag || kpisubFlag || breakupFlag || trendsFlag ||  comparisonFlag || comparisonPlantFlag || ipmvpFlag">
                <div class="tabbing_content">
                    <app-commontabs class="tab_class_one" [tabsArr]="uiTabs" [selectedIndex]="getidvalue"
                        (tabClicked)="uiSwitchTab($event, uiTabs)" >
                    </app-commontabs >
                    <div *ngIf="showsecondblock" class="tabbing_content_sub_tab pt-2" >
                        <app-commontabs class="tab_class_two tab_underline" [tabsArr]="uiSubTabs"
                            [selectedIndex]="getsubidvalue" (tabClicked)="uiSwitchSubMenu($event, uiSubTabs)">
                        </app-commontabs>
                    </div>
                </div>
            </div>
            <div class="tab_section_one position-relative" *ngIf="reportFlag || alertFlag || dadqFlag || adminFlag || assetViewFlag">
                <span class="card_head_text" *ngIf="!adminFlag && !dadqFlag && !assetViewFlag">PLANT</span>
                <span class="card_head_text" *ngIf="dadqFlag">ENTERPRISE / PLANT</span>
                <app-commontabs class="tab_class_two tab_underline" [tabsArr]="uiTabs" [selectedIndex]="getidvalue"
                    (tabClicked)="uiSwitchTab($event, uiTabs)">
                </app-commontabs>
                <div class="common_select" *ngIf="assetViewFlag">
                    <div *ngIf="assetViewreportFlag == false">
                        <app-commonselect [selectOptionsArr]="assetOptionsArr" [selectedValue]="selectedValue"
                            (onSelectChange)="onSelectChange($event)">
                        </app-commonselect>
                    </div>
                </div>
            </div>
            <router-outlet></router-outlet>
        </div>
    </ng-container>
    <footer class="footer">
        <p>Copyright © 2022 | TCS Clever Energy<sup>TM</sup>. All Right Reserved.</p>
    </footer>
</div>